import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as actionsPasoDos from '../_redux/pasoDos/pasoDosActions';
import * as actionsPasoUno from '../_redux/pasoUno/pasoUnoActions';
import { PreInscripcionUIConsumer, PreInscripcionUIContext } from '../PreInscripcionUIContext';
//ICONOS
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
//TOOLTIPS
import { OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap'
//BOTONES
import Volver from '../components/Volver';
import { Button } from 'react-bootstrap';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';
//MODAL PERSONALIZADO PARA ELIMINAR
import ModalDelete from '../../../Comun/Modal/ModalDelete';

import SnackBarCustom from '../../../Comun/SnackBars/SnackBarCustom';


//ISO PAISES/PROVINCIAS 
import Countries from '../../../../../_metronic/countries/Countries';
//Formateo loas paises a array
const paises = Countries();

const AgregarOtroResponsable = (props) => {
    const { goToStep } = props;
    const dispatch = useDispatch();

    const { pasoUno } = useSelector(
        (state) => ({ pasoUno: state.pasoUno }),
        shallowEqual
    );
    const { id: idPasoUno, inscripcionNumero, inscripcionId } = pasoUno;


    //ESTADOS
    const [submitPasoSiguiente, setSubmitPasoSiguiente] = useState(false);
    const [eliminarResponsable, setEliminarResponsable] = useState(false);
    const [verModal, setVerModal] = useState(false);
    const [cambiarPrincipal, setCambiarPrincipal] = useState(false);
    const [responsable, setResponsable] = useState({});
    const { cantidadResponsables, dispatchDatosPeronales, verResponsables, responsablePrincipalPosicion } = useContext(PreInscripcionUIContext);
    //EDITAR RESPONSABLE
    function editarPaso(i) {
        if (i === 0) {
            goToStep(2);
        } else
            if (i === 1) {
                goToStep(4);
            } else
                if (i === 2) {
                    goToStep(6);
                };
    };

    //QUITAR RESPONSABLE
    const quitarResponsable = () => {
        dispatchDatosPeronales({ type: 'quitarResponsable', payload: { posicion: responsable.posicion } });
        dispatch(actionsPasoUno.stateQuitarResponsables({}))
        setEliminarResponsable(!eliminarResponsable);
        cerrarModal();
        if (cantidadResponsables() === 0) {
            goToStep(2);
        };
    };

    //ABRIR MODAL
    function abrirModal(i, documentoNumero, nombre, apellido) {
        setResponsable({ posicion: i, documentoNumero, nombre: apellido + ", " + nombre });
        setVerModal(true);
    };

    //CERRAR MODAL
    const cerrarModal = () => {
        setResponsable({});
        setVerModal(false);
    };

    const { pasoDos } = useSelector(
        (state) => ({ pasoDos: state.pasoDos }),
        shallowEqual
    );

    const {
        actionsLoading: actionsLoadingPaso2,
        error: errorPaso2
    } = pasoDos;

    //IR A ESTABLECIMIENTOS
    function irEstablecimiento() {
        scrollTop();

        const responsablesContext = verResponsables();
        let responsables = []

        responsablesContext.forEach((item, i) => {
            const { id, aspiranteResponsableId,
                sexo, documentoNumero: nroDocumento, //validadoPorElRegistroCivil,
                nombre, apellido, pais, provincia, localidad: localidadNacimiento, fechaNacimiento: fNacimiento,
                personaRegistroCivilId, vinculo, vinculoId, telefono, email
            } = item;
            const { domicilioId, calle: domicilioCalle, numero: domicilioNumero, piso: domicilioPiso, dpto: domicilioDpto,
                departamento: domicilioDepartamento, localidad: domicilioLocalidad
            } = item.domicilio;
            const fechaNacimiento = fNacimiento.toISOString();
            //const prioridad = responsablePrincipalPosicion() === i ? "Principal" : "Secundario"
            responsables.push({
                id: id ? id : null, 
                sexo, 
                nroDocumento, 
                nombre, 
                apellido,
                fechaNacimiento, 
                paisNacimiento: paises[pais].countryName, 
                provinciaNacimiento: paises[pais].regions[provincia].name,
                localidadNacimiento, 
                domicilioId, 
                domicilioCalle, 
                domicilioNumero, 
                domicilioPiso, 
                domicilioDpto, 
                domicilioDepartamento, 
                domicilioLocalidad, //validadoPorElRegistroCivil, 
                personaRegistroCivilId: personaRegistroCivilId ? personaRegistroCivilId : 0,
                esAspirante: false, 
                esResponsable: true, 
                inscripcionId, 
                inscripcionNumero:'',
                aspiranteResponsableId: aspiranteResponsableId ? aspiranteResponsableId : 0,
                email, 
                telefono,
                vinculo, 
                vinculoId, 
                prioridad: i + 1
            });
        });
        dispatch(actionsPasoDos.fetchPasoDosAlTres({ 
            //id: idPasoUno, 
            inscripcionId, 
            //inscripcionNumero, 
            responsables 
        }));
        setSubmitPasoSiguiente(true);
    };

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        if (submitPasoSiguiente && !actionsLoadingPaso2 && !errorPaso2) {
            setSubmitPasoSiguiente(false);
            goToStep(8);
        };
    }, [actionsLoadingPaso2, errorPaso2, submitPasoSiguiente])

    return (
        <PreInscripcionUIConsumer>
            {value =>
                <>
                    {value.cantidadResponsables() < 3 &&
                        <li className="d-flex flex-row align-items-center mb-3">
                            <h2>¿Agregar otro responsable?</h2>
                            <Fab className="ml-4 mb-2" size="small" style={{ backgroundColor: "#1BC5BD" }} onClick={() => editarPaso(value.cantidadResponsables())}>
                                <AddIcon style={{ color: "white" }} fontSize="small" />
                            </Fab>
                        </li>
                    }
                    {value.cantidadResponsables() > 0 &&
                        <>
                            {value.responsablePrincipalPosicion() > value.cantidadResponsables() - 1 &&
                                value.dispatchDatosPeronales({ type: 'guardarResponsablePrincipalPosicion', payload: { posicion: value.cantidadResponsables() - 1 } })
                            }
                            {cambiarPrincipal ?
                                <div className="form-group">
                                    <label>Seleccione el responsable principal</label>
                                    <select className="form-control" onChange={(e) => {
                                        value.dispatchDatosPeronales({ type: 'guardarResponsablePrincipalPosicion', payload: { posicion: parseInt(e.currentTarget.value) } })
                                    }}>
                                        <option >{value.obtenerResponsablePrincipal()}</option>
                                        {value.cantidadResponsables() > 0 && value.verResponsables().map((responsable, i) =>
                                            value.responsablePrincipalPosicion() !== i &&
                                            <option key={i} value={i}>{responsable.apellido}, {responsable.nombre} ({responsable.vinculo})</option>
                                        )}
                                    </select>
                                    <Button className="mt-3 mb-3" variant="success" size="sm" onClick={() => setCambiarPrincipal(false)}>Aceptar</Button>
                                </div>
                                :
                                <div className="form-group">
                                    <h4>Reponsable Principal:</h4>
                                    <li>
                                        <b>{value.obtenerResponsablePrincipal()} </b>
                                        {value.cantidadResponsables() > 1 &&
                                            <Button variant="link" size="sm" onClick={() => setCambiarPrincipal(true)}>Cambiar</Button>
                                        }
                                    </li>
                                </div>
                            }
                        </>
                    }
                    <h4>Responsables ({value.cantidadResponsables()} de 3):</h4>
                    {eliminarResponsable && value.cantidadResponsables() > 0 && value.verResponsables().map((responsable, i) =>
                        <li key={i}>
                            <b>{responsable.apellido}, {responsable.nombre} ({responsable.vinculo})</b>
                            <Button size="sm" variant="link" onClick={() => editarPaso(i)}>Editar</Button>
                            <OverlayTrigger placement="left" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Quitar responsable</Tooltip>}>
                                <IconButton className="mb-1" onClick={() => abrirModal(i, responsable.documentoNumero, responsable.nombre, responsable.apellido)}><DeleteIcon color="error" /></IconButton>
                            </OverlayTrigger>
                        </li>
                    )}
                    {!eliminarResponsable && value.cantidadResponsables() > 0 && value.verResponsables().map((responsable, i) =>
                        <li key={i}>
                            <b>{responsable.apellido}, {responsable.nombre} ({responsable.vinculo})</b>
                            <Button size="sm" variant="link" onClick={() => editarPaso(i)}>Editar</Button>
                            <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Quitar responsable</Tooltip>}>
                                <IconButton className="mb-1" onClick={() => abrirModal(i, responsable.documentoNumero, responsable.nombre, responsable.apellido)}><DeleteIcon color="error" /></IconButton>
                            </OverlayTrigger>
                        </li>
                    )}
                    <ModalDelete
                        show={verModal}
                        close={cerrarModal}
                        title="Responsable"
                        text={`¿Desea quitar a ${responsable.nombre} de la lista de responsables?`}
                        deleteFunction={quitarResponsable}
                    />
                    <div className="row justify-content-center mb-3">
                        <Volver ultimoPaso={2} {...props} />
                        <Button className="ml-4" variant="success" size="sm" style={{ width: 115 }}
                            onClick={() => {
                                //value.setUltimoPaso(currentStep);
                                irEstablecimiento();
                            }}
                        >Continuar {!actionsLoadingPaso2 ? <ArrowForwardIcon /> : <Spinner animation="border" variant="light" size="sm" />}</Button>
                    </div>
                    {errorPaso2 && <SnackBarCustom tipo="error" mensaje={errorPaso2} />}
                </>
            }
        </PreInscripcionUIConsumer >
    )
};

export default AgregarOtroResponsable;